 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERIMAGE from '@/components/CoverImage'
 import WRIGHT_WHO_WAS_JESUS_TEXT from '@/components/Wright_Who_Was_Jesus_text'
 import COPYRIGHT from '@/components/Copyright'
 import DEDICATION from '@/components/Dedication'
 import WRIGHT_WHO_WAS_JESUS_TEXT1 from '@/components/Wright_Who_Was_Jesus_text-1'
 import WRIGHT_WHO_WAS_JESUS_TEXT2 from '@/components/Wright_Who_Was_Jesus_text-2'
 import WRIGHT_WHO_WAS_JESUS_TEXT3 from '@/components/Wright_Who_Was_Jesus_text-3'
 import WRIGHT_WHO_WAS_JESUS_TEXT4 from '@/components/Wright_Who_Was_Jesus_text-4'
 import WRIGHT_WHO_WAS_JESUS_TEXT5 from '@/components/Wright_Who_Was_Jesus_text-5'
 import WRIGHT_WHO_WAS_JESUS_TEXT6 from '@/components/Wright_Who_Was_Jesus_text-6'
 import WRIGHT_WHO_WAS_JESUS_TEXT7 from '@/components/Wright_Who_Was_Jesus_text-7'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverImage",
 			"name" : "CoverImage",
 			"component" : COVERIMAGE
 		},
 		{
 			"path" : "/Wright_Who_Was_Jesus_text",
 			"name" : "Wright_Who_Was_Jesus_text",
 			"component" : WRIGHT_WHO_WAS_JESUS_TEXT
 		},
 		{
 			"path" : "/Copyright",
 			"name" : "Copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Wright_Who_Was_Jesus_text-1",
 			"name" : "Wright_Who_Was_Jesus_text-1",
 			"component" : WRIGHT_WHO_WAS_JESUS_TEXT1
 		},
 		{
 			"path" : "/Wright_Who_Was_Jesus_text-2",
 			"name" : "Wright_Who_Was_Jesus_text-2",
 			"component" : WRIGHT_WHO_WAS_JESUS_TEXT2
 		},
 		{
 			"path" : "/Wright_Who_Was_Jesus_text-3",
 			"name" : "Wright_Who_Was_Jesus_text-3",
 			"component" : WRIGHT_WHO_WAS_JESUS_TEXT3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js